module.exports = __webpack_public_path__ + "static/media/ic-angle-right.b22d767f.svg";